export interface Plan {
  id: string;
  headline: string;
  subhead: string;
  priceMonthly: string;
  priceYearly: string | null;
  yearlyNote: string | null;
  ctaText: string;
  ctaLink: string;
  ctaPrimary: boolean;
  badge: string | null;
  features: string[];
}

export const plans: Plan[] = [
  {
    id: 'single',
    headline: 'Single User',
    subhead: 'One driver or dispatcher.',
    priceMonthly: '$20 / month',
    priceYearly: '$204 / year',
    yearlyNote: 'Equivalent to $17/month — save 15%',
    ctaText: 'Start now',
    ctaLink: '/contact',
    ctaPrimary: true,
    badge: null,
    features: [
      'Search Echo, CH Robinson, Uber Freight, and RXO in one query',
      'Unified results with origin/destination radius, date, equipment, and weight filters',
      'Connect your own broker credentials',
      'Deep-link to book on each broker',
      'One user login',
    ],
  },
  {
    id: 'fleet',
    headline: 'Fleet',
    subhead: 'Multiple dispatchers under one company.',
    priceMonthly: 'Contact us for details.',
    priceYearly: null,
    yearlyNote: null,
    ctaText: 'Contact us',
    ctaLink: '/contact',
    ctaPrimary: false,
    badge: 'Recommended for fleets',
    features: [
      'Everything in Single User',
      'Company account with multiple user logins',
      'Shared broker credentials managed centrally',
      'Admin panel for users and broker connections',
      'Search audit log',
    ],
  },
];

export const reassurances = [
  'Connect your own broker accounts — we don\'t resell loads.',
  'No long-term contract on the single-user plan.',
  'Multi-broker coverage: Echo, CH Robinson, Uber Freight, RXO.',
];

export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 1,
    question: 'How do broker credentials work?',
    answer:
      'Each user (or company) connects their existing Echo, CHR, Uber Freight, and RXO accounts. LoadAPI runs searches under those credentials and never resells loads.',
  },
  {
    id: 2,
    question: 'Can I add teammates later?',
    answer:
      'Single User is one login. To add dispatchers, switch to the Fleet plan from the Contact Us page.',
  },
  {
    id: 3,
    question: 'Can I switch between monthly and yearly?',
    answer:
      'Yes, you can change your billing cadence from your account settings at any time.',
  },
];
